import { render, staticRenderFns } from "./commonHistory.vue?vue&type=template&id=7e20e05c&scoped=true"
import script from "./commonHistory.vue?vue&type=script&lang=js"
export * from "./commonHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e20e05c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e20e05c')) {
      api.createRecord('7e20e05c', component.options)
    } else {
      api.reload('7e20e05c', component.options)
    }
    module.hot.accept("./commonHistory.vue?vue&type=template&id=7e20e05c&scoped=true", function () {
      api.rerender('7e20e05c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/QSPI/OtherTargetMaintain/commonHistory.vue"
export default component.exports